import React from "react";
import { Row, Col } from "react-bootstrap";
import Buy from "./Buy";
import Rocket from "./Rocket";
import Share from "./Share";
import TransactionsTable from "./TransactionsTable";
import Affiliates from "./Affiliates";
function Index(props) {
  return (
    <Col className="live-presale-max-width mt-0 presale-live-background">
      <Row className="justify-content-center ">
        <Col
          xs={12}
          sm={10}
          lg={6}
          className="d-flex flex-column justify-content-between"
        >
          {/* <Rocket {...props} /> */}
          <Share />
        </Col>
      </Row>
      <Row className="justify-content-center mt-4 ">
        <Col xs={12} sm={10} lg={6}>
          <Buy />
        </Col>
      </Row>
      <Row className="justify-content-center pb-5">
        <Col xs={12} sm={10} lg={10} xl={10}>
          <TransactionsTable />
        </Col>
        {/* <Col xs={12} sm={10} lg={10} xl={10}>
          <Affiliates />
        </Col> */}
        {/* <Col xs={12} sm={10} lg={5} xl={4}>
          <Purchased refetch={refetch} />
        </Col> */}
      </Row>
    </Col>
  );
}

export default Index;
